import { Container } from "react-bootstrap";
import ExcercisesResumeRow from "../ExcercisesResumeRow";

const ExcercisesResumeList = ({exercises = []}) => {
  return (
    <Container className="pt-4">
      {
        exercises.map((ex) => (
          <ExcercisesResumeRow title={ex.name} reps={ex.reps} thumbnail={ex.thumbnail} />
        ))
      }
    </Container>
  );
};

export default ExcercisesResumeList;
